module.exports = __webpack_public_path__ + "img/ano_novo.64e0f029.svg";